import { render, staticRenderFns } from "./MainLedgerCardHead.vue?vue&type=template&id=56b962a5"
import script from "./MainLedgerCardHead.vue?vue&type=script&lang=js"
export * from "./MainLedgerCardHead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports